import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { INovelty } from '../../../../backoffice/novelties/models/novelties'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'
import { getClientNovelties } from '../../../../../redux/actions/novelties'
import { IRootState } from '../../../../../redux/types'

export const useNewsData = () => {
  const dispatch = useDispatch()
  const { news } = useSelector((state: IRootState) => state.novelty)
  const { globalFamilyId, globalBrandId, globalCountryId, globalLanguageId, globalTag, globalRoleId } = useSelector(
    (state: IRootState) => state.global
  )
  const [highlightNews, setHighlightNews] = useState<INovelty[]>([])
  const [noHighlightNews, setNoHighlightNews] = useState<INovelty[]>([])

  useEffect(() => {
    if (news.length > 0) {
      let tmpHighlightNews = news.filter((currentNews: any) => {
        if (currentNews.highlight === 1) return currentNews
      })
      let tmpNoHighlightNews = news.filter((currentNews: any) => {
        if (currentNews.highlight === 0 || currentNews.highlight === null) return currentNews
      })

      setHighlightNews(tmpHighlightNews)
      setNoHighlightNews(tmpNoHighlightNews)
    } else {
      setHighlightNews([])
      setNoHighlightNews([])
    }
  }, [news])

  useEffect(() => {
    dispatch(
      getClientNovelties({
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        country_id: globalCountryId,
        language_id: globalLanguageId,
        tag_id: globalTag,
        role_id: globalRoleId,
        type: 'news',
        requesttype: 2
      })
    )
  }, [globalFamilyId, globalBrandId, globalCountryId, globalLanguageId, globalTag, globalRoleId, dispatch])

  const cutContent = (content: string) => {
    let trimmedString: string = ''
    trimmedString = content.substr(0, Math.min(content.length, content.indexOf('</p>')))
    return trimmedString
  }

  const handleFavoriteClick = (id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id,
          state,
          type: 'novelty',
          favoritefield: 'news'
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id,
          state,
          type: 'novelty',
          favoritefield: 'news'
        })
      )
    }
  }

  return {
    highlightNews,
    noHighlightNews,
    cutContent,
    handleFavoriteClick
  }
}
